"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _BrandIcons = require("../BrandIcons");

var _core = require("@emotion/core");

var SvgBPublicProfessionalPositive = function SvgBPublicProfessionalPositive(props) {
  return (0, _core.jsx)(_BrandIcons.BrandIcons, props, (0, _core.jsx)("g", {
    fill: "none",
    fillRule: "evenodd"
  }, (0, _core.jsx)("path", {
    d: "M77.584 61.26c-3.52 0-6.985-.879-10.08-2.557a2.116 2.116 0 012.037-3.709 17.006 17.006 0 10-8.92-15.2 2.108 2.108 0 01-4.215-.057c.162-11.69 9.747-21.049 21.438-20.932 11.69.117 21.086 9.666 21.015 21.357-.072 11.691-9.583 21.124-21.275 21.098z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M11.941 24.86a2.107 2.107 0 01-1.088-3.913l16.296-9.834A72.148 72.148 0 0196.635 8.24l2.81 1.404a38.297 38.297 0 0031.307 1.167 2.107 2.107 0 111.58 3.905 42.49 42.49 0 01-34.756-1.3l-2.81-1.37a67.94 67.94 0 00-65.467 2.705l-16.304 9.834a2.108 2.108 0 01-1.054.274z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M141.548 81.251a2.108 2.108 0 01-2.107-1.798l-10.038-66.388a2.107 2.107 0 014.166-.632l10.066 66.388a2.107 2.107 0 01-1.77 2.402c-.105.016-.21.026-.317.028zM126.284 93.993a42.526 42.526 0 01-18.81-4.397l-2.81-1.405a68.523 68.523 0 00-44.254-5.62 2.107 2.107 0 11-.864-4.123 72.738 72.738 0 0146.965 5.964l2.81 1.405a38.297 38.297 0 0031.307 1.173 2.107 2.107 0 111.58 3.906 42.519 42.519 0 01-15.924 3.097z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M76.601 81.244c-.38.001-.754-.1-1.082-.295l-8.17-4.882a2.115 2.115 0 112.192-3.617l7.186 4.298c7.952-3.877 14.822-7.024 21.481-10.129 12.286-5.675 23.019-10.635 34.94-17.56-8.69-6.323-14.9-12.258-20.92-17.976-4.088-3.885-7.958-7.551-12.362-11.127C85.326 8.156 77.739 6.16 75.983 5.837c-18.383 7.706-34.75 23.23-34.911 23.384a2.107 2.107 0 11-2.916-3.041c.703-.703 17.372-16.514 36.731-24.459.274-.113.568-.168.864-.162.871 0 8.977.703 26.742 15.117 4.538 3.68 8.43 7.404 12.644 11.344 6.504 6.175 13.234 12.567 23.082 19.479a2.107 2.107 0 01-.127 3.512c-13.248 7.93-24.768 13.248-38.114 19.416-6.919 3.196-14.049 6.497-22.415 10.585-.298.151-.628.23-.962.232z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M29.228 74.6a9.132 9.132 0 01-6.518-2.698 2.107 2.107 0 012.978-2.979 5.001 5.001 0 100-7.073 2.108 2.108 0 11-2.985-2.979A9.216 9.216 0 0138.43 65.39a9.21 9.21 0 01-9.202 9.21z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M48.567 97.906H15.109a2.107 2.107 0 01-2.107-2.107 16.564 16.564 0 0128.273-11.71 2.118 2.118 0 01-2.978 3.013 12.356 12.356 0 00-20.898 6.624h29.06V51.39H14.05v27.817a2.107 2.107 0 11-4.215 0V49.283c0-1.164.944-2.107 2.107-2.107H48.54c1.163 0 2.107.943 2.107 2.107V95.8a2.107 2.107 0 01-2.08 2.107z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M48.63 111.112H12.033a2.107 2.107 0 110-4.215H48.63a2.107 2.107 0 010 4.215z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M48.567 124.374H2.107A2.107 2.107 0 010 122.267v-82.93a2.107 2.107 0 114.215 0v80.822h44.352a2.107 2.107 0 110 4.215z",
    fill: "#1B7"
  }), (0, _core.jsx)("path", {
    d: "M24.227 41.353H12.075a2.107 2.107 0 010-4.215h12.152a2.107 2.107 0 010 4.215zM58.513 124.374a2.107 2.107 0 01-2.107-2.107V41.353h-14.26a2.107 2.107 0 110-4.215h16.367c1.164 0 2.107.943 2.107 2.107v83.022a2.107 2.107 0 01-2.107 2.107z",
    fill: "#285"
  }), (0, _core.jsx)("path", {
    d: "M31.968 41.388h-9.996a2.107 2.107 0 01-2.107-2.108V29.3c0-1.164.943-2.108 2.107-2.108h19.943c1.163 0 2.107.944 2.107 2.108v9.897a2.107 2.107 0 01-4.215 0v-7.79H24.08v5.767h7.888a2.107 2.107 0 110 4.215z",
    fill: "#1B7"
  })));
};

var _default = SvgBPublicProfessionalPositive;
exports["default"] = _default;